<div class="card" *ngIf="creationPatient==false || filter==false" style="height:90vh;">
  <div class="card-body">

    <!-- TOP -->
    <div class="top-row">
      <select-drop-down
        [items]="doctorPatients"
        [(ngModel)]="userTarget"
        [placeHolder]="'Chercher ici Patient'"
        [options]="{ filter:{ byKey:'fullName',with:'containe' } }"
        class="full-width"
      >
        <ng-template let-item="item">
          <div class="user-item">
            <img [src]="item | avatarSrc" />
            <span>{{item.getFullName()}}</span>
          </div>
        </ng-template>
      </select-drop-down>

      <button class="btn btn-primary button" (click)="creationPatient=true;filter=!filter">
        <i class="feather-plus"></i>
      </button>
    </div>

    <div *ngIf="(!userTarget || !userTarget.id) && submited" class="text-danger mt-2">
      Veuillez sélectionner un patient
    </div>

    <!-- FORM -->
    <div class="form-container">

      <div class="divRow">
        <label class="label">Date Rdv</label>
        <input type="text" class="form-control" [value]="date" />
      </div>

      <!-- HEURE -->
      <div class="divRow" *ngIf="secrectary.doctor.duplicateAppointment==false">
        <label class="label">Heure Rdv</label>
        <select [(ngModel)]="disponibilite" (change)="change($event)" class="form-control">
          <option disabled selected>Choisir une option</option>
          <option *ngFor="let dispo of disponibilites " [ngValue]="dispo">
            {{dispo.startTime | time}}
          </option>
               <option [ngValue]="disponibilite" *ngIf="disponibiliteDefalut!==0 && changeValueDisponibilte==false" disabled selected
              >{{disponibiliteDefalut |time}}</option
            >
          <option *ngIf="(disponibilites )?.length === 0" disabled>
            Aucune disponibilité
          </option>
        </select>
      </div>

      <div class="divRow" *ngIf="secrectary.doctor.duplicateAppointment==true">
        <label class="label">Heure Rdv</label>
        <input type="time" class="form-control" [(ngModel)]="heureInput" (change)="onTimeChange($event)" />
      </div>

      <!-- INTERVENANT + COLOR -->
      <div class="form-row-double" *ngIf="secrectary.doctor.duplicateAppointment == true">

        <div class="intervenant">
          <label class="label">Intervenant</label>
          <select [(ngModel)]="selectedUser" class="form-control" (change)="onUserChange()">
            <option *ngFor="let user of usersList" [ngValue]="user">
        {{ user.type === 'DOCTOR' ? "Dr."+user.fullName : user.fullName }} ({{ user.type === 'DOCTOR' ? 'Médecin' : 'Assistant' }})
            </option>
          </select>
        </div>

        <div class="color">
          <div class="color-picker-wrapper" (click)="toggleDropdown()">
            <div class="selected-color">
              <span class="circle" [style.background]="doctorAppointment.colorCode"></span>
            </div>
            <span class="color-arrow">▼</span>

            <ul class="color-dropdown" *ngIf="isOpen">
              <li *ngFor="let c of colors" (click)="selectColor(c.value)">
                <span class="circle" [style.background]="c.value"></span>
              </li>
            </ul>
          </div>
        </div>

      </div>

      <!-- LOCATION -->
      <div class="divRow">
        <label class="label">Location</label>

        <div class="radio-container">
          <label *ngIf="secrectary.doctor.timeSlotLocalSetting | locationEnabled: 'cabinet'">
            <input type="radio" name="location" [(ngModel)]="location" [value]="0"/>
            <span>En Cabinet</span>
          </label>

          <label *ngIf="secrectary.doctor.timeSlotLocalSetting | locationEnabled: 'online'">
            <input type="radio" name="location" [(ngModel)]="location" [value]="1"/>
            <span>A Distance</span>
          </label>
        </div>
      </div>

      <!-- MOTIF -->
      <div class="divRow">
        <label class="label">Motif</label>
        <select [(ngModel)]="doctorAppointment.motif" class="form-control">
          <option value="Consultation Régulière">Consultation Régulière</option>
          <option value="Consultation Controle">Consultation Controle</option>
          <option *ngFor="let motif of consultationMotifs" [value]="motif.text"
            [ngStyle]="{'color':motif.color || '#820040'}">
            {{motif.text}}
          </option>
        </select>
      </div>
 <div class="divRow" *ngIf="secrectary.doctor.duplicateAppointment==false">
        
<label for="" class="label">couleur</label>
  <div class="color-picker-wrapper" (click)="toggleDropdown()">
  <!-- Cercle affiché dans l'input -->
  <div class="selected-color">
    <span class="circle" [style.background]="doctorAppointment.colorCode"></span>
  </div>
  <span class="color-arrow">▼</span>

  <!-- Liste des couleurs -->
  <ul class="color-dropdown" *ngIf="isOpen">
    <li *ngFor="let c of colors" 
        (click)="selectColor(c.value)">
      <span class="circle" [style.background]="c.value"></span>
    </li>
  </ul>
</div>
                    </div>
      <!-- SUBMIT -->
      <div class="submit-section">
        <button class="btn btn-primary submit-btn"
          [disabled]="!userTarget || !userTarget.id"
          (click)="sumbit()">
          Enregistrer
        </button>
      </div>

    </div>
    
  </div>
</div>

<app-create-patient-secretary
  *ngIf="creationPatient==true && filter==true"
  (completed)="refresh($event)"
  [(isFilter)]="creationPatient">
</app-create-patient-secretary>